/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,

    authority:
      'https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477',
    redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

/* 
945b42a6-a3cf-407a-9fd8-ad713c1cc6f
App Name	snowflake-commander
Application (client) ID	3e12ccee-015f-4acd-b51b-e8371cae9690

3e12ccee-015f-4acd-b51b-e8371cae9690
3e12ccee-015f-4acd-b51b-e8371cae969

Object ID	ac7b27a0-2f06-42ac-bbd2-93953065dbce
Directory (Tenant) ID	254ba93e-1f6f-48f3-90e6-e2766664b477
App Type	Web
Redirect URL	https://localhost:3000

OAuth 2.0 authorization endpoint (v2)	https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477/oauth2/v2.0/authorize

OAuth 2.0 token endpoint (v2)	https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477/oauth2/v2.0/token

App Owner	eduardo.dixo@siemens-energy.com

Claims	GID, email */
